module.exports = __webpack_public_path__ + "img/KSC04127.beaab7f9.jpg";